import axios from 'axios';
import { API_BASE_URL } from './config';
import { createBackendReadiness } from './utils/backendWakeup';

export { API_BASE_URL };

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 35000,
});

export const ensureBackendReady = createBackendReadiness(() =>
  axios.get(`${API_BASE_URL}/health`, { timeout: 60000 })
);

function isHealthRequest(config) {
  const url = String(config.url || '').split('?')[0].replace(/\/+$/, '');
  return url === '/health' || url.endsWith('/health');
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.request.use(async config => {
  if (!config.skipBackendWarmup && !isHealthRequest(config)) {
    await ensureBackendReady();
  }
  return config;
});

export default api;
